import { doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAppSelector } from "../storeHooks";
import { fireStore } from "../../firebase";
import { iUserDetails } from "../../types/userType";

export const useOnUpdateUserNotifications = (callback: () => void) => {
  const user = useAppSelector(
    (state) => state.user?.userDetails as iUserDetails
  );
  const [notificationsUpdated, setNotificationUpdated] =
    useState<Timestamp | null>(null);

  useEffect(() => {
    let unsubscribe: () => void;
    if (fireStore && user?.id) {
      const documentRef = doc(fireStore, "vendors", user.id);
      unsubscribe = onSnapshot(documentRef, (doc) => {
        if (doc.exists()) {
          setNotificationUpdated(doc.data().notificationsUpdated);
        }
      });
    }
    return () => unsubscribe && unsubscribe();
  }, [user]);

  useEffect(() => {
    callback();
  }, [notificationsUpdated]);
};
